import * as React from "react";

export type CollabPostButtonProps = {
  disabled?: boolean;
  loading?: boolean;
  /** When true, uses filled emphasis style (WordPlugin ready state). */
  ready?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
  type?: "button" | "submit";
};

export const CollabPostButton: React.FC<CollabPostButtonProps> = ({
  disabled,
  loading,
  ready = false,
  onClick,
  children = "Post",
  type = "button",
}) => (
  <button
    type={type}
    className={`collab-post-btn${ready && !disabled && !loading ? " is-ready" : ""}`}
    disabled={disabled || loading}
    aria-busy={loading || undefined}
    onClick={onClick}
  >
    {loading ? "Posting…" : children}
  </button>
);

export default CollabPostButton;
